import { useState } from "react";
import ArtCard from "../components/ArtCard";
import Lightbox from "../components/Lightbox";

export default function GalleryPage({ galleryItems }) {
  const [selected, setSelected] = useState(null);

  return (
    <div className="page">
      <div className="section">
        <div className="section-header">
          <div className="section-ornament">
            <div className="section-ornament-line" />
            <span className="section-label">The Collection</span>
            <div className="section-ornament-line" />
          </div>
          <h2 className="section-title">
            Gallery of <em>Works</em>
          </h2>
          <div className="section-rule" />
        </div>

        {galleryItems.length === 0 ? (
          <div style={{ textAlign: "center", color: "var(--ink-faint)", padding: "80px 0", fontStyle: "italic" }}>
            No gallery pieces yet. Upload photos or videos from Admin.
          </div>
        ) : (
          <div className="cards-grid">
            {galleryItems.map((item) => (
              <ArtCard
                key={item.id}
                item={item}
                variant="gallery"
                onClick={() => setSelected(item)}
              />
            ))}
          </div>
        )}
      </div>

      {selected && (
        <Lightbox item={selected} variant="gallery" onClose={() => setSelected(null)} />
      )}
    </div>
  );
}
